import ACCOUNTS_MARKETPLACE_API from 'api/accounts-marketplace/v1'
import { call, put, takeLatest } from 'redux-saga/effects'
import { FETCH_ORDERS, SET_DATA, SET_LOADING } from 'modules/AccountsMarketplace/Category/types'

function* fetchOrders({ payload }) {
  try {
    yield put({ type: SET_LOADING, payload: { loading: true } })

    const { response, error } = yield call(
      ACCOUNTS_MARKETPLACE_API.fetchOrders,
      {
        params: payload.params,
      },
    )

    if (error) {
      throw error
    }

    yield put({
      type: SET_DATA,
      payload: response.data,
    })
  } catch (error) {
    console.logXHR(error)
  } finally {
    yield put({ type: SET_LOADING, payload: { loading: false } })
  }
}

export default function* Sagas() {
  yield takeLatest(FETCH_ORDERS, fetchOrders)
}
